import { useCallback, useSyncExternalStore } from 'react';

// TCA-26101913: renderer-lifetime exclusion only. Native owners retain durable recovery.
// No credentials, payloads or saved artifacts are retained in this registry.
const bridges = new WeakMap();
const listeners = new Set();
const subscribe = listener => { listeners.add(listener); return () => listeners.delete(listener); };
const notify = () => { for (const listener of listeners) listener(); };
export default function useRendererOperation(bridge, group) {
  const lookup = useCallback(() => bridges.get(bridge)?.get(group) || null, [bridge, group]);
  const claim = useSyncExternalStore(subscribe, lookup, () => null);
  const acquire = kind => {
    if (!bridge || lookup()) return null;
    let groups = bridges.get(bridge);
    if (!groups) { groups = new Map(); bridges.set(bridge, groups); }
    const token = { kind, phase: 'pending' };
    groups.set(group, token); notify();
    return token;
  };
  const settle = (token, phase = null) => {
    const groups = bridges.get(bridge);
    if (groups?.get(group) !== token) return;
    if (phase) groups.set(group, { kind: token.kind, phase });
    else groups.delete(group);
    notify();
  };
  return { claim, lookup, acquire, settle };
}
